(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ["pointermove", "mousemove"];
